import { Link } from 'react-router-dom'

interface HeaderProps {
  title: string
  /** Ziel des Zurueck-Pfeils; ohne Angabe fuehrt er zur Startseite. */
  backTo?: string
  right?: React.ReactNode
}

export function Header({ title, backTo = '/', right }: HeaderProps) {
  return (
    <header className="header">
      <Link to={backTo} className="header__back" aria-label="Zurueck">
        &#8592;
      </Link>
      <h1 className="header__title">{title}</h1>
      <div className="header__right">{right}</div>
    </header>
  )
}
